/** Tanzania / UK style: day/month/year (DD/MM/YYYY). */

const DISPLAY_LOCALE = 'en-GB';

export function formatDisplayDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(DISPLAY_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDisplayDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(DISPLAY_LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** YYYY-MM-DD (API) → DD/MM/YYYY (display). */
export function isoToDisplay(iso) {
  if (!iso) return '';
  const match = String(iso).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }
  return formatDisplayDate(iso);
}

/** DD/MM/YYYY or DD-MM-YYYY → YYYY-MM-DD (API). Returns null if invalid. */
export function displayToIso(display) {
  const text = String(display ?? '').trim();
  if (text === '') return '';

  const match = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);

  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) {
    return null;
  }

  const iso = `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  const check = new Date(`${iso}T12:00:00`);
  if (
    check.getFullYear() !== year
    || check.getMonth() + 1 !== month
    || check.getDate() !== day
  ) {
    return null;
  }

  return iso;
}

/** YYYY-MM-DD for DateInput when loading from API (full date only; year-only stays blank). */
export function parseReleaseDateForForm(value) {
  if (value === null || value === undefined || value === '') return '';
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  return '';
}

/** API/storage value → YYYY-MM-DD for submit (prefer form, else keep stored full date). */
export function releaseDateForSubmit(formValue, storedValue) {
  const fromForm = normalizeReleaseDateValue(formValue);
  if (fromForm && /^\d{4}-\d{2}-\d{2}$/.test(fromForm)) return fromForm;

  const stored = String(storedValue ?? '').trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(stored)) return stored;
  if (/^\d{4}$/.test(stored) && !fromForm) return stored;

  if (fromForm && /^\d{4}$/.test(fromForm)) return `${fromForm}-01-01`;

  return fromForm || '';
}

/** API/storage value → YYYY-MM-DD for DateInput (legacy year-only → YYYY-01-01). */
export function normalizeReleaseDateValue(value) {
  if (value === null || value === undefined || value === '') return '';
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (/^\d{4}$/.test(s)) return `${s}-01-01`;
  const fromDisplay = displayToIso(s);
  if (fromDisplay) return fromDisplay;
  return s;
}

/** Today's date as YYYY-MM-DD (local timezone). */
export function todayIsoDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
